import axios from 'axios';
import { config } from '../shared/app.config';
import store from '../store/store';

const RESOURCE_NAME = '/app/dish_group';


export default {
    getAllByRestaurant(restaurant_id, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        return axios.get(`${config.webApiBase + RESOURCE_NAME  }/${restaurant_id}`, {
            headers: {
                'X-localization': language
            }
        });
    },

    create(dish_group_name, language) {

        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                //'Content-Type': 'multipart/form-data',
                'X-localization': language
            }
        };

        return axios.post(config.webApiBase + RESOURCE_NAME + `/create`, dish_group_name, requestConfig)

    },

    assignToDishGroup(dish_ids, language) {

        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language
            }
        };

        return axios.post(config.webApiBase + RESOURCE_NAME + `/assign`, dish_ids, requestConfig)
    },



    edit(dish_group, id, language) {

        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-localization': language
            }
        };
        return axios.post(config.webApiBase + RESOURCE_NAME + `/modify/${id}`, dish_group, requestConfig);
    },

    delete(id) {
        return axios.get(`${config.webApiBase + RESOURCE_NAME }/delete/${  id}`);
    },
    getOne(id, language) {

        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                'X-localization': language
            }
        };
        return axios.get(`${config.webApiBase + RESOURCE_NAME  }/one/${  id}`, requestConfig);
    },
}